import {
  BoxedBatteryIcon,
  BoxedBatteryIcon2024,
  BoxedDiamondIcon,
  BoxedSensingIcon,
  BoxedSensorsIcon,
  BoxedTitaniumIcon,
  BoxedWaterDropIcon,
  BoxedWaterResistIcon,
} from '@jouzen/ecom-components';
import type { SVGIconComponent } from 'types/svgr';

import type { WizardCarouselImageContent } from '@/app/[locale]/product/_steps/wizardData/types';

export interface SlideshowItemIconProps
  extends Pick<WizardCarouselImageContent, 'iconName'> {
  readonly className?: string;
}

const SlideshowItemIcon = ({
  className,
  iconName,
}: SlideshowItemIconProps): JSX.Element => {
  let Icon: SVGIconComponent;
  switch (iconName) {
    case 'sensors_boxed':
      Icon = BoxedSensorsIcon;
      break;
    case 'battery_boxed':
      Icon = BoxedBatteryIcon;
      break;
    case 'titanium_boxed':
      Icon = BoxedTitaniumIcon;
      break;
    case 'water_resist_boxed':
      Icon = BoxedWaterResistIcon;
      break;
    case 'battery_boxed_2024':
      Icon = BoxedBatteryIcon2024;
      break;
    case 'diamond_boxed':
      Icon = BoxedDiamondIcon;
      break;
    case 'sensing_boxed':
      Icon = BoxedSensingIcon;
      break;
    case 'water_drop_boxed':
      Icon = BoxedWaterDropIcon;
      break;
    default:
      Icon = BoxedSensorsIcon;
  }

  return (
    <Icon className={className} data-cy={`slideshow-item-icon-${iconName}`} />
  );
};

export default SlideshowItemIcon;
